// Navigation intent is separate from business authority. Widgets still resolve
// their current scope, permissions and workflow stage after loading the record.
const PURPOSES = {
  assessment: { workspace: 'application', step: null },
  eligibility: { workspace: 'application', step: 'eligibility' },
  'submitted-assessment': { workspace: 'application', step: 'review' },
  documents: { workspace: 'application', step: null },
  'intervention-followup': { workspace: 'case', step: null },
  'payment-proof': { workspace: 'case', step: null },
};
const QUEUE_PURPOSES = {
  'file-complete-processing-due': 'assessment',
  'in-assessment': 'assessment',
  'ei-consent-verification': 'eligibility',
  'pending-assessment': 'eligibility',
  'approvals-pipeline': 'submitted-assessment',
  'missing-docs': 'documents',
  'active-clients-checkins': 'intervention-followup',
  'followups-closure': 'intervention-followup',
  'payments-proof-due': 'payment-proof',
};
const positiveId = value => Number.isSafeInteger(Number(value)) && Number(value) > 0 ? Number(value) : null;

export const parseTaskWorkspaceEntry = search => {
  const params = search instanceof URLSearchParams ? search : new URLSearchParams(search || '');
  if (params.get('entry') !== 'task') return null;
  const purpose = params.get('task');
  const definition = PURPOSES[purpose];
  if (!definition) return null;
  const ids = Object.fromEntries(['applicationId', 'planId', 'interventionId', 'packetId', 'lineId']
    .map(key => [key, positiveId(params.get(key))]));
  // Do not turn a malformed precise task into selection of the first item.
  const invalidTarget = Object.keys(ids).some(key => params.has(key) && !ids[key]) ||
    (definition.workspace === 'application' && !ids.applicationId) ||
    (purpose === 'intervention-followup' && !ids.interventionId) ||
    (purpose === 'payment-proof' && !ids.packetId);
  return {
    mode: 'task', purpose, ...definition, ...ids, invalidTarget,
    key: ['task', purpose, ...Object.values(ids).map(id => id || 'none')].join(':'),
  };
};

export const withQueueTaskEntry = (path, item) => {
  const purpose = QUEUE_PURPOSES[item?.bucketId];
  if (!purpose || !/^\/(?:application-case|cases)\/\d+(?:[?#]|$)/.test(path || '')) return path;
  const url = new URL(path, 'https://path.invalid');
  // Explicit review/completion and appeal links already know their destination.
  if (url.searchParams.has('entry') || url.searchParams.has('appeal')) return path;
  const expectedPath = PURPOSES[purpose].workspace === 'application' ? '/application-case/' : '/cases/';
  if (!url.pathname.startsWith(expectedPath)) return path;
  url.searchParams.set('entry', 'task');
  url.searchParams.set('task', purpose);
  const ids = {
    applicationId: item.applicationId ?? item.application_id,
    planId: item.actionPlanId ?? item.action_plan_id,
    interventionId: item.interventionId ?? item.intervention_id,
    packetId: item.packetId,
    lineId: item.lineId,
  };
  Object.entries(ids).forEach(([key, value]) => {
    const id = positiveId(value);
    if (id && !url.searchParams.has(key)) url.searchParams.set(key, String(id));
  });
  return url.pathname + url.search + url.hash;
};
